export default async function(requests) {
  const result = await Promise.allSettled(requests);
  return result.map(({ value }) => value);
}